export enum ActionType
{
    UPDATE_NOTEBOOK = '[NOTEBOOK] UPDATE_NOTEBOOK',
    EMPTY_STATE = '[NOTEBOOK] EMPTY_STATE',
    COPY_NOTE = '[NOTEBOOK] COPY_NOTE'
}
